import { Component, OnInit } from '@angular/core';
import { Usuario,RegistroService,Planteles,Cargos} from 'src/app/services/registro.service';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { EmpleadoService } from '../../../services/empleado.service';

@Component({
  selector: 'app-nuevousuario',
  templateUrl: './nuevousuario.component.html',
  styleUrls: ['./nuevousuario.component.css']
})
export class NuevousuarioComponent implements OnInit {

  datos=JSON.parse(localStorage.getItem('datos')!);
  mailusu= this.datos.email;
  opcionSeleccionado:any;
  verSeleccion: any;
  plantel:any;
  seleccionados:any=[];
  numempleado:any;

  capturar() {
    this.verSeleccion = this.usuario.cargo;
}

getdocenteselect(){
  this.seleccionados = this.usuario.numemp
  console.log(this.seleccionados)

}

  usuario: Usuario={
    email:'',
    nombre:'',
    password:'',
    cargo:0,
    plantel:'',
    numemp:0,
    idplantel:0,
    mailusuario:this.mailusu

  };
  planteles:string;
  Nombre:string;
  ListarEquipo: Planteles[] = [];
  Cargos: Cargos[] = [];
  docentes: any = [];
  administrativo: any = [];
  datosUsuario: any = [];
  validaCorreo = "^[a-z0-9._%+-]+@cecytev.edu.mx$";
  constructor(private registro:RegistroService,private router:Router,private msj:mensajeSesionExpiradaService, private EmpleadoService:EmpleadoService) { 
    this.planteles=this.datos.planteles;
    this.Nombre=this.datos.nom;
    
  }

  ngOnInit(): void {
    var cargo=localStorage.getItem('cargo');
    this.getCargo();
    this.listarPlanteles();
    this.getDocente(this.plantel);
    this.getAdministrativo(this.plantel);
    this.seleccionarDocente(this.datosUsuario)
  }
  getCargo(){
    this.registro.getCargos().subscribe(
      res=>{
      this.Cargos=<any>res; //Pasamos todos los registros al arreglo ListarEquipo
      
      },
      err=>console.log(err)
    );
  
  }




  RegistrarUsuario(form:NgForm,email:any){
  
    if(form.invalid){
      console.log('Formulario Invalido');
      Swal.fire(
        'Advertencia!',
        '¡Campos Incorrectos!',
        'info'
      )
      return;
}else{
console.log("valor de usuario.cargo "+this.usuario.cargo);
    this.registro.addUsuario(this.usuario).subscribe((res) => {

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      if(res=='Agregado'){
        // console.log(res);
        Swal.fire(
              'Aviso!',
              'Registro Satisfactorio!',
              'success'
            )
            localStorage.setItem('email',email);
            this.router.navigate(['/dashboard']);
      }else{
        // console.log(res);
        Swal.fire(
          'Error al crear la cuenta',
          '¡Este email ya fue registrado!',
          'error'
        )
      }
     },(err : HttpErrorResponse)=>{
       console.log(err);
    });

  }

  }

  listarPlanteles(){

    this.registro.getPlanteles().subscribe(
      res=>{

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }
      // console.log(res)
      this.ListarEquipo=<any>res; //Pasamos todos los registros al arreglo ListarEquipo
      },
      err=>console.log(err)
    );
  }

  getDocente(plantel:any){
    this.registro.getDocentes(plantel).subscribe(
      res=> {

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }

         this.docentes = res;
      
      },
      // err => console.error(err)
      
    );
  }

  getAdministrativo(plantel:any){
     console.log(plantel)
    this.registro.getAdministrativo(plantel).subscribe(
      res=> {

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }

         this.administrativo = res;
        //  console.log(this.administrativo)
      
      },
      // err => console.error(err)
      
    );
  }


  seleccionarDocente(value:any){
    // console.log(value) 
    this.EmpleadoService.getEmpleadoUsuario(value).subscribe(
      res=> {

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }

         this.datosUsuario = res;
        // console.log(this.datosUsuario)
        this.usuario.nombre =this.datosUsuario.nombre + " " + this.datosUsuario.appaterno + " " + this.datosUsuario.apmaterno
        this.usuario.email = this.datosUsuario.correoinstitucional
      },
      // err => console.error(err)
      
    ); 
  
  }

}
